<template>
  <div class="titlerow" />
</template>

<script>
export default {};
</script>

<style scoped>
.titlerow {
  height: 64px;
  border-bottom: 1px solid var(--border);
}
</style>
